// extracted by mini-css-extract-plugin
export var actionIcon = "_lt-0";